function _isStaging() {
  if (process.env.NODE_ENV === "PROD") return false;
  return window.location.toString().includes(".webflow.io");
}

export const isStaging = _isStaging();
